import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import Loader from "../../../../../../../../../common/Loader";

// `compact` : un bouton nommé et une aide « ou glissez un fichier ici », à la
// place du cadre pointillé ; la zone entière accepte toujours un fichier glissé.
const DropZone = ({ onDropFiles, isUploading, dataPriv = "", compact = false, label = "Déposer un fichier" }) => {
  const onDrop = (acceptedFiles) => {
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (
      acceptedFiles.length > 0 &&
      allowedTypes.indexOf(acceptedFiles[0].type) != -1 &&
      !isUploading
    ) {
      onDropFiles(acceptedFiles);
    } else {
      alert(
        "Le fichier choisi est incorrect. Les formats acceptés sont jpeg, png et pdf."
      );
    }
  };

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    noClick: compact,
    noKeyboard: compact,
  });

  if (compact) {
    return (
      <StyledDropzoneCompact {...getRootProps()} data-priv={dataPriv} className={isDragActive ? "survol" : ""}>
        <input {...getInputProps()} />
        <button type="button" className="depot" onClick={open} disabled={isUploading}>
          {isUploading ? <Loader size={14} /> : <i className="fa fa-file-upload" aria-hidden="true" />}
          {label}
        </button>
        <span className="aide">{isDragActive ? "Déposez le fichier ici" : "ou glissez un fichier sur cette zone"}</span>
      </StyledDropzoneCompact>
    );
  }

  return (
    <div {...getRootProps()} data-priv={dataPriv}>
      <input {...getInputProps()} />
      <StyledDropzone className="d-center text-center p-2 rounded mb-2 ">
        {isUploading ? (
          <Loader />
        ) : isDragActive ? (
          <div>Déposer le fichier ici</div>
        ) : (
          <div>
            Déposez un fichier ici, ou cliquez pour parcourir vos dossiers
          </div>
        )}
      </StyledDropzone>
    </div>
  );
};

const StyledDropzone = styled.div`
  height: 76px;
  background: rgb(251, 251, 251);
  border: 1px dashed #b2b2b2;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
`;

const StyledDropzoneCompact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 4px;
  margin: 0 -4px;
  border-radius: 6px;
  transition: background 150ms;

  // Bouton secondaire sur les jetons --ds-* (pas .btn-default, au rendu daté).
  .depot {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 30px;
    padding: 0 10px;
    border: 1px solid var(--ds-slate-300);
    border-radius: 8px;
    background: white;
    color: var(--ds-slate-700);
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    transition: background 150ms, color 150ms;

    > i {
      font-size: 12px;
      color: var(--ds-slate-500);
    }
    &:hover {
      background: var(--ds-slate-100);
      color: var(--ds-slate-900);
    }
    &:hover > i {
      color: inherit;
    }
    &:focus-visible {
      outline: 2px solid var(--ds-blue);
      outline-offset: 2px;
    }
    &:disabled {
      opacity: 0.55;
      cursor: progress;
    }
  }
  .aide {
    font-size: 12px;
    color: var(--ds-slate-500);
  }
  &.survol {
    background: var(--ds-blue-soft);
    box-shadow: inset 0 0 0 2px var(--ds-blue);
  }

  @media (max-width: 767px) {
    .depot {
      height: 44px;
      padding: 0 14px;
    }
  }
`;

export default DropZone;
